import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store/store';
import { paramsUsuario, paramsPoliza } from './lib/utils/utilitarios';
import GestionInversionFVG from './domains/gestionInversionFVG/containers/gestionInversionFVG';
import InformacionDevolucion from './domains/informacionDevolucion/containers/informacionDevolucion';
import ConsultaRescate from './domains/consultaRescate/containers/consultaRescate';

import './assets/styles/variables.scss';

function App() {

  useEffect(() => {
    const query = new URLSearchParams(document.location.search);
    sessionStorage.setItem("infoToken", decodeURIComponent(query.get('token')));
    sessionStorage.setItem("infoUsuario",paramsUsuario(query.entries()));
    sessionStorage.setItem("infoPoliza", paramsPoliza(query.entries()));
  }, []);

  console.log(process.env.REACT_APP_ENVIRONMENT);

  return (
    <Router>
      <Provider store={store}>
        <Routes>
          <Route exact path="/" element={<GestionInversionFVG />} />
          <Route exact path="/devolucion" element={<InformacionDevolucion />} />
          <Route exact path="/rescate" element={<ConsultaRescate />} />
        </Routes>
      </Provider>
    </Router>
  );
}

export default App;
